var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-jin-nang-table',{attrs:{"titleList":_vm.titleList,"dataList":_vm.dataList},on:{"row-clicked":_vm.repoClick,"titleSort":_vm.titleSort}})
}
var staticRenderFns = []

export { render, staticRenderFns }